import React, { useState, useEffect } from 'react'
import { Table, Panel, ButtonGroup } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'

export default function FilterHistory({ schema, header, onPreview, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  console.log('schema', schema)
  return (
    <>
      <Panel header={header} bordered collapsible shaded defaultExpanded>
        <Table wordWrap height={400} data={schema?.tableData || []}>
          {schema?.stepTitle && (
            <Column width={200}>
              <HeaderCell align="center">
                <span>{schema.stepTitle}</span>
              </HeaderCell>
              <Cell dataKey="step" />
            </Column>
          )}

          <Column flexGrow={1} width={300}>
            <HeaderCell align="center">
              <span>{schema?.projectStatusTitle}</span>
            </HeaderCell>
            <Cell dataKey="topicEditHeader" />
          </Column>
          <Column width={160}>
            <HeaderCell align="center">
              <span>{schema?.dateFilterTitle}</span>
            </HeaderCell>
            <Cell dataKey="dateFilter" />
          </Column>
          <Column width={160}>
            <HeaderCell align="center">
              <span>{schema?.dateEditTitle}</span>
            </HeaderCell>
            <Cell dataKey="dateEdit" />
          </Column>
          <Column width={160}>
            <HeaderCell align="center">
              <span>{schema?.dateSendEditTitle}</span>
            </HeaderCell>
            <Cell dataKey="dateSendEdit" />
          </Column>

          <Column width={70} align="center">
            <HeaderCell align="center">
              <span>{schema?.version}</span>
            </HeaderCell>
            <Cell dataKey="version" />
          </Column>

          <Column width={60} align="center" fixed="right">
            <HeaderCell>
              <span></span>
            </HeaderCell>

            <Cell>
              {(rowData) => {
                return (
                  <ButtonGroup>
                    <TooltipButton
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={(e) => onPreview(rowData)}
                    ></TooltipButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
